import { ChangeDetectionStrategy, Component, Input, HostBinding } from '@angular/core';
import { ICmsAbstractButtonComponent } from '../icms-abstract-button.component';

export type TUiButtonStyles = 'dark' | 'light' | 'accent' | 'transparent';

@Component({
    standalone: false,
    selector: 'button[iCmsUiButton], a[iCmsUiButton]',
    templateUrl: 'icms-ui-button.html',
    styleUrls: ['./icms-ui-button.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ICmsUiButtonComponent extends ICmsAbstractButtonComponent {
    @Input()
    iCmsUiButton: TUiButtonStyles = 'dark';

    @HostBinding('class._active')
    @Input()
    active?: boolean = false;

    @HostBinding('class._disabled')
    @Input()
    disabled?: boolean = false;

    @HostBinding('class._size30')
    @Input()
    size30?: boolean = false;

    protected variantInputName = 'iCmsUiButton';
}
